import { Component, OnInit  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-import-request',
  templateUrl: './import-request.component.html',
  providers: [DatePipe]
})
export class ImportRequestComponent implements OnInit {
  public errorMessage;
  public postId;
  public codigo;
  public accion;
  public volver;
  public estado;
  public email: string;
  public numeroserial: string;
  public fecharegistro: string;
  public today;
  public dateend;
  myDate = new Date();
  public lenguajeGlobal;

  public origen: string = "import";

  ShowTouristData = true;
  ShowTransportData = false;
  ShowLoadedFiles = true;
  TDNoSelect = false; TDSelect = true;
  TRSelect = false; TRNoSelect = true;
  LFSelect = false; LFNoSelect = true;
    
  public SolicitudShow = true;
  public ConsultarShow = false;
  public ProrrogaShow = false;
  public ShowOther = false;
  public ShowRejection = false;

  public showModalBoxsave = false;
  showModalRequired: boolean = false;
  showModalBoxCancelar: boolean = false;

  Seccionales: SeccionalAduanera[];
  Paises: Pais[];
  Ciudades: Ciudad[];
  FormasIngreso: FormaIngreso[];
  LugaresIngreso: LugarIngreso[];

  seccional: SeccionalAduanera;

  import: Import;
  imports: Import[];
  extend: Extend;
  extends: Extend[];

  wait: boolean = true;
  cancel: boolean = false;
  ok: boolean = false;
  ext: boolean = false;
  ven: boolean = false;
  fin: boolean = false;

  errornacionalidadId: boolean = false;
  errordiasAutorizadosId: boolean = false;
  errornumeroDocumento1166Id: boolean = false;
  erroranoModeloId: boolean = false;
  erroraduanaIngreso: boolean = false;
  erroraduanaSalida: boolean = false;
  errornombreTuristaId: boolean = false;
  errorpaisResidenciaTurista: boolean = false;
  errornumeroPasaporteId: boolean = false;
  errornacionalidadIdRequerido: boolean = false;
  errorfechaLlegadaId: boolean = false;
  errorciudadHospedajeId: boolean = false;
  errordireccionHospedajeId: boolean = false;
  errordiasAutorizadosIdRequerido: boolean = false;
  errorcorreoElectronicoId: boolean = false;
  errorfechaIngresoId: boolean = false;
  errorfechaSalidaId: boolean = false;
  errorformaIngresoVehiculoId: boolean = false;
  errornumeroDocTransporteId: boolean = false;
  errornumeroDocumento1166IdRequerido: boolean = false;
  errornumerodocpropiedad: boolean = false;
  errorfechaMatricula: boolean = false;
  errorclaseId: boolean = false;
  erroridMedioTransporteVIN: boolean = false;
  errorplacaPaisMatricula: boolean = false;
  errormarcaId: boolean = false;
  erroranoModeloIdRequerido: boolean = false;
  errornumeroMotorId: boolean = false;
  errorpaisMatriculaId: boolean = false;
  errorcolorId: boolean = false;
  errornombreBuqueId: boolean = false;
  errornombreBanderaId: boolean = false;
  errorlugarIngresoId: boolean = false;
  errornumeroMatriculaId: boolean = false;
  errorcarMedioTransporte: boolean = false;
  erroranotherChars: boolean = false;
  errortipoId: boolean = false;

  public sendmail: SendMail;

  public tooladuanaIngreso: string;
  public tooladuanaSalida: string;
  public toolpaisResidenciaTurista: string;
  public toolciudadHospedajeId: string;
  public toolformaIngreso: string;
  public toolclase: string;
  public toolpaisMatriculaId: string;
  public toolnombreBanderaId: string;
  public toollugarIngreso: string;

  solicitudForm = this.formBuilder.group({
    aduanaIngreso: new FormControl('', [Validators.required]),
    aduanaSalida: new FormControl('', [Validators.required]),
    nombreTuristaId: new FormControl('', [Validators.required]),
    paisResidenciaTurista: new FormControl('', [Validators.required]),
    numeroPasaporteId: new FormControl('', [Validators.required]),
    nacionalidadId: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z\s]*$/)]),
    fechaLlegadaId: new FormControl('', [Validators.required]),
    ciudadHospedajeId: new FormControl('', [Validators.required]),
    direccionHospedajeId: new FormControl('', [Validators.required]),
    diasAutorizadosId: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    correoElectronicoId: new FormControl(''),
    fechaIngresoId: new FormControl('', [Validators.required]),
    fechaSalidaId: new FormControl('', [Validators.required]),
    formaIngresoVehiculoId: new FormControl('', [Validators.required]),
    numeroDocTransporteId: new FormControl(''),
    numeroDocumento1166Id: new FormControl('', [Validators.pattern(/^[0-9]*$/)]),
    numerodocpropiedad: new FormControl('', [Validators.required]),
    fechaMatricula: new FormControl('', [Validators.required]),
    claseId: new FormControl('', [Validators.required]),
    idMedioTransporteVIN: new FormControl(''),
    placaPaisMatricula: new FormControl('', [Validators.required]),
    marcaId: new FormControl('', [Validators.required]),
    anoModeloId: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    numeroMotorId: new FormControl('', [Validators.required]),
    paisMatriculaId: new FormControl('', [Validators.required]),
    colorId: new FormControl('', [Validators.required]),
    nombreBuqueId: new FormControl(''),
    nombreBanderaId: new FormControl(''),
    lugarIngresoId: new FormControl('', [Validators.required]),
    numeroMatriculaId: new FormControl('', [Validators.required]),
    carMedioTransporte: new FormControl('', [Validators.required]),
    anotherChars: new FormControl('', [Validators.required]),
    tipoId: new FormControl('', [Validators.required]),
    justificationRejection: new FormControl(''),
    customTarget: new FormControl('')
  });

  constructor(private http: HttpClient, private rutaActiva: ActivatedRoute, private formBuilder: FormBuilder, private datePipe: DatePipe, private router: Router, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionTurista");
    var lenguaje = this.cookies.get("lenguajeTurista");
    this.lenguajeGlobal = lenguaje;    
    if (token == "") {
      this.router.navigate(["/validate-email"]);
    }
  }

  get customTargetValue() { return this.solicitudForm.get('customTarget'); }

  ngOnInit() {
    var lenguaje = this.cookies.get("lenguajeTurista");
    this.lenguajeGlobal = lenguaje;    
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.accion = this.rutaActiva.snapshot.params.accion
    this.postId = this.rutaActiva.snapshot.params.idimport
    this.email = this.rutaActiva.snapshot.params.email
    this.numeroserial = this.rutaActiva.snapshot.params.numserial
    this.volver = this.rutaActiva.snapshot.params.volver
    this.fecharegistro = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    var valor = Math.floor(Math.random() * (99999 - 10000)) + 10000;
    this.codigo = this.numeroserial.toLowerCase() + "-" + valor.toString();
    this.ShowLoadedFiles = false;

    this.today = new Date().toJSON().split('T')[0];
    this.dateend = new Date().toJSON().split('T')[0];

    this.solicitudForm.controls["numeroDocTransporteId"].disable();
    this.solicitudForm.controls["numeroDocumento1166Id"].disable();
    this.solicitudForm.controls["nombreBuqueId"].disable();
    this.solicitudForm.controls["nombreBanderaId"].disable();
    this.solicitudForm.controls["justificationRejection"].disable();

    if (this.accion == "consulta") {
      this.SolicitudShow = false;
      this.ConsultarShow = true;
      this.solicitudForm.controls["aduanaIngreso"].disable();
      this.solicitudForm.controls["aduanaSalida"].disable();
      this.solicitudForm.controls["nombreTuristaId"].disable();
      this.solicitudForm.controls["paisResidenciaTurista"].disable();
      this.solicitudForm.controls["numeroPasaporteId"].disable();
      this.solicitudForm.controls["nacionalidadId"].disable();
      this.solicitudForm.controls["fechaLlegadaId"].disable();
      this.solicitudForm.controls["ciudadHospedajeId"].disable();
      this.solicitudForm.controls["direccionHospedajeId"].disable();
      this.solicitudForm.controls["diasAutorizadosId"].disable();
      this.solicitudForm.controls["correoElectronicoId"].disable();
      this.solicitudForm.controls["fechaIngresoId"].disable();
      this.solicitudForm.controls["fechaSalidaId"].disable();
      this.solicitudForm.controls["formaIngresoVehiculoId"].disable();
      this.solicitudForm.controls["numeroDocTransporteId"].disable();
      this.solicitudForm.controls["numeroDocumento1166Id"].disable();
      this.solicitudForm.controls["numerodocpropiedad"].disable();
      this.solicitudForm.controls["fechaMatricula"].disable();
      this.solicitudForm.controls["claseId"].disable();
      this.solicitudForm.controls["idMedioTransporteVIN"].disable();
      this.solicitudForm.controls["placaPaisMatricula"].disable();
      this.solicitudForm.controls["marcaId"].disable();
      this.solicitudForm.controls["anoModeloId"].disable();
      this.solicitudForm.controls["numeroMotorId"].disable();
      this.solicitudForm.controls["paisMatriculaId"].disable();
      this.solicitudForm.controls["colorId"].disable();
      this.solicitudForm.controls["nombreBuqueId"].disable();
      this.solicitudForm.controls["nombreBanderaId"].disable();
      this.solicitudForm.controls["lugarIngresoId"].disable();
      this.solicitudForm.controls["numeroMatriculaId"].disable();
      this.solicitudForm.controls["carMedioTransporte"].disable();
      this.solicitudForm.controls["anotherChars"].disable();
      this.solicitudForm.controls["tipoId"].disable();

      //const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
      this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=" + this.postId + "&approvednumber=&sectionaladdresin=")
        .subscribe({
          next: data => {
            
            this.imports = data as Import[];
            this.import = this.imports[0];
            this.codigo = this.import.nombreContenedor;
            this.postId = this.import.id;

            this.http.get<any>(`${environment.baseUrl}v1/parametros/5?codigo=` + this.import.sectionalAddressIn)
              .subscribe({
                next: data => {
                  this.LugaresIngreso = data as LugarIngreso[];
                  this.toollugarIngreso = this.LugaresIngreso.filter(se => se.codigo == this.import.entryPlace)[0].nombre;
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })

            this.solicitudForm.patchValue({
              aduanaIngreso: this.import.sectionalAddressIn,
              aduanaSalida: this.import.sectionalAddressOut,
              nombreTuristaId: this.import.touristName,
              paisResidenciaTurista: this.import.touristCountry,
              numeroPasaporteId: this.import.passportNumber,
              nacionalidadId: this.import.nationality,
              fechaLlegadaId: this.import.dateOfArrival,
              ciudadHospedajeId: this.import.touristCity,
              direccionHospedajeId: this.import.touristAddress,
              diasAutorizadosId: this.import.authorizedDuration,
              correoElectronicoId: this.import.email,
              fechaIngresoId: this.import.dateIn,
              fechaSalidaId: this.import.dateOut,
              formaIngresoVehiculoId: this.import.vehicleEntryForm,
              numeroDocTransporteId: this.import.transportDocumentNumber,
              numeroDocumento1166Id: this.import.n1166DocumentNumber,
              numerodocpropiedad: this.import.ownershipDocumentNumber,
              fechaMatricula: this.import.registrationDate,
              claseId: this.import.typeClass,
              idMedioTransporteVIN: this.import.chassisNumber,
              placaPaisMatricula: this.import.licensePlate,
              marcaId: this.import.make,
              anoModeloId: this.import.model,
              numeroMotorId: this.import.engineNumber,
              paisMatriculaId: this.import.countryOfRegistration,
              colorId: this.import.color,
              nombreBuqueId: this.import.transportationName,
              nombreBanderaId: this.import.nameFlag,
              lugarIngresoId: this.import.entryPlace,
              numeroMatriculaId: this.import.registrationNumber,
              carMedioTransporte: this.import.transportationChars,
              anotherChars: this.import.othersChars,
              tipoId: this.import.typeVehicle,
              justificationRejection: this.import.justification
            });

            this.toolformaIngreso = (this.import.vehicleEntryForm == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por Carga" : "Per charge") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por sus propios medios" : "On their own"))
            this.toolclase = (this.import.typeClass == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Automóviles y demás vehículos terrestres" : "Cars and other land vehicles") : (this.import.typeClass == "2" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Barcos y demás artefactos flotantes" : "Boats and floating structures") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Aeronaves" : "Aircraft")))

            this.estado = (this.import.idStatus == "1" ? "EN REVISIÓN" : (this.import.idStatus == "2" ? "APROBADA" : (this.import.idStatus == "3" ? "RECHAZADA" : (this.import.idStatus == "4" ? "SOLICITUD PRÓRROGA" : (this.import.idStatus == "5" ? "PRORROGA APROBADA" : (this.import.idStatus == "6" ? "VENCIDA" : (this.import.idStatus == "7" ? "FINALIZADA" : "")))))))

            if (this.import.idStatus == "1") {
              this.wait = true;
              this.cancel = false;
              this.ok = false;
              this.ext = false;
              this.ven = false;
              this.fin = false;
              this.ShowRejection = false;
            }
            else if (this.import.idStatus == "2") {
              this.wait = false;
              this.cancel = false;
              this.ok = true;
              this.ext = false;
              this.ven = false;
              this.fin = false;
              this.ShowRejection = false;
            }
            else if (this.import.idStatus == "3") {
              this.wait = false;
              this.cancel = true;
              this.ok = false;
              this.ext = false;
              this.ven = false;
              this.fin = false;
              this.ShowRejection = true;
            }
            else if (this.import.idStatus == "4") {
              this.wait = false;
              this.cancel = false;
              this.ok = false;
              this.ext = true;
              this.ven = false;
              this.fin = false;
              this.ShowRejection = false;
            }
            else if (this.import.idStatus == "5") {
              this.wait = false;
              this.cancel = false;
              this.ok = true;
              this.ext = false;
              this.ven = false;
              this.fin = false;
              this.ShowRejection = false;
            }
            else if (this.import.idStatus == "6") {
              this.wait = false;
              this.cancel = false;
              this.ok = false;
              this.ext = false;
              this.ven = true;
              this.fin = false;
              this.ShowRejection = false;
            }
            else if (this.import.idStatus == "7") {
              this.wait = false;
              this.cancel = false;
              this.ok = false;
              this.ext = false;
              this.ven = false;
              this.fin = true;
              this.ShowRejection = false;
            }           

            this.fecharegistro = this.import.importDate.substring(0, 10);

            this.http.get<any>(`${environment.baseUrl}v1/extend/1?idImport=` + this.import.id + "&sectionaladdress=&status=&idextend=")
              .subscribe({
                next: data => {
                  this.extends = data as Extend[];
                  this.extend = this.extends[0];

                  if (this.extend == null) {
                    this.ProrrogaShow = false;
                  }
                  else {
                    this.ProrrogaShow = true;
                    for (let e in this.extends) {
                      this.extends[e].estado = (this.extends[e].idStatus == "1" ? "EN REVISIÓN" : (this.extends[e].idStatus == "2" ? "APROBADA" : (this.extends[e].idStatus == "3" ? "RECHAZADA" : (this.extends[e].idStatus == "4" ? "SOLICITUD PRÓRROGA" : (this.extends[e].idStatus == "5" ? "PRORROGA APROBADA" : (this.extends[e].idStatus == "6" ? "VENCIDA" : (this.extends[e].idStatus == "7" ? "FINALIZADA" : "")))))))
                      this.http.get<any>(`${environment.baseUrl}v1/parametros/8?codigo=` + this.extends[e].sectionalAddress)
                        .subscribe({
                          next: data => {
                            var seccional = data as SeccionalAduanera;
                            this.extends[e].sectionalName = seccional.nombre;
                          }
                        })
                    }
                  }
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })

            this.http.get<any>(`${environment.baseUrl}v1/parametros/1?codigo=`)
              .subscribe({
                next: data => {
                  this.Seccionales = data as SeccionalAduanera[];
                  this.tooladuanaIngreso = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressIn)[0].nombre;
                  this.tooladuanaSalida = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressOut)[0].nombre;
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })
            this.http.get<any>(`${environment.baseUrl}v1/parametros/2?codigo=`)
              .subscribe({
                next: data => {
                  this.Paises = data as Pais[];
                  this.toolpaisResidenciaTurista = this.Paises.filter(se => se.codigo == this.import.touristCountry)[0].nombre;
                  this.toolpaisMatriculaId = this.Paises.filter(se => se.codigo == this.import.countryOfRegistration)[0].nombre;
                  this.toolnombreBanderaId = this.Paises.filter(se => se.codigo == this.import.nameFlag)[0].nombre;
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })
            this.http.get<any>(`${environment.baseUrl}v1/parametros/3?codigo=`)
              .subscribe({
                next: data => {
                  this.Ciudades = data as Ciudad[];
                  this.toolciudadHospedajeId = this.Ciudades.filter(se => se.codigo == this.import.touristCity)[0].nombre;
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })
            this.http.get<any>(`${environment.baseUrl}v1/parametros/4?codigo=`)
              .subscribe({
                next: data => {
                  this.FormasIngreso = data as FormaIngreso[];
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })

            let element: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
            element.click();

          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })
    }
    else {
      this.http.get<any>(`${environment.baseUrl}v1/parametros/1?codigo=`)
        .subscribe({
          next: data => {
            this.Seccionales = data as SeccionalAduanera[];
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })
      this.http.get<any>(`${environment.baseUrl}v1/parametros/2?codigo=`)
        .subscribe({
          next: data => {
            this.Paises = data as Pais[];
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })
      this.http.get<any>(`${environment.baseUrl}v1/parametros/3?codigo=`)
        .subscribe({
          next: data => {
            this.Ciudades = data as Ciudad[];
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })
      this.http.get<any>(`${environment.baseUrl}v1/parametros/4?codigo=`)
        .subscribe({
          next: data => {
            this.FormasIngreso = data as FormaIngreso[];
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })

      this.SolicitudShow = true;
      this.ConsultarShow = false;
      let element6: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
      element6.click();
    }

    
    
  }

  saveImport() {
    let element1: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element1.click();
    if (this.solicitudForm.valid) {
      var formaingreso = this.solicitudForm.controls["formaIngresoVehiculoId"].value;
      var numDocTrans = this.solicitudForm.controls["numeroDocTransporteId"].value;
      var numDoc1166 = this.solicitudForm.controls["numeroDocumento1166Id"].value;
      var clase = this.solicitudForm.controls["claseId"].value;
      var nomBuque = this.solicitudForm.controls["nombreBuqueId"].value;
      var nomBandera = this.solicitudForm.controls["nombreBanderaId"].value;
      var archivo = this.cookies.get("cargaarchivo" + this.origen);

        if ((formaingreso == "1" && (numDocTrans == "" || numDoc1166 == "")) || archivo == "" || (clase == "2" && (nomBuque == "" || nomBandera == ""))) {
          let element3: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element3.click();

          if (formaingreso == "1") {
            this.cambionumeroDocTransporteId();
            this.cambionumeroDocumento1166Id();
          }
          if (clase == "2") {
            this.cambionombreBuqueId();
            this.cambionombreBanderaId();
          }

          let element2: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
          element2.click();
          this.solicitudForm.controls["customTarget"].setValue("errorModal");
          if (archivo == "") {          
            if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
              this.errorMessage = "Debes cargar los archivos obligatorios, por favor";
            } else {
              this.errorMessage = "You must upload the required files, please";
            }
          }
          else {
            if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
              this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
            } else {
              this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
            }
          }        
      }
      else {
        this.import = new Import();
        this.import.sectionalAddressIn = this.solicitudForm.controls["aduanaIngreso"].value;
        this.import.sectionalAddressOut = this.solicitudForm.controls["aduanaSalida"].value;
        this.import.touristName = this.solicitudForm.controls["nombreTuristaId"].value;
        this.import.touristCountry = this.solicitudForm.controls["paisResidenciaTurista"].value;
        this.import.passportNumber = this.solicitudForm.controls["numeroPasaporteId"].value;
        this.import.nationality = this.solicitudForm.controls["nacionalidadId"].value;
        this.import.dateOfArrival = this.solicitudForm.controls["fechaLlegadaId"].value;
        this.import.touristCity = this.solicitudForm.controls["ciudadHospedajeId"].value;
        this.import.touristAddress = this.solicitudForm.controls["direccionHospedajeId"].value;
        this.import.authorizedDuration = this.solicitudForm.controls["diasAutorizadosId"].value;
        this.import.email = this.email;
        this.import.dateIn = this.solicitudForm.controls["fechaIngresoId"].value;
        this.import.dateOut = this.solicitudForm.controls["fechaSalidaId"].value;
        this.import.vehicleEntryForm = this.solicitudForm.controls["formaIngresoVehiculoId"].value;
        this.import.transportDocumentNumber = this.solicitudForm.controls["numeroDocTransporteId"].value;
        this.import.n1166DocumentNumber = this.solicitudForm.controls["numeroDocumento1166Id"].value;
        this.import.ownershipDocumentNumber = this.solicitudForm.controls["numerodocpropiedad"].value;
        this.import.registrationDate = this.solicitudForm.controls["fechaMatricula"].value;
        this.import.typeClass = this.solicitudForm.controls["claseId"].value;
        this.import.chassisNumber = this.numeroserial;
        this.import.licensePlate = this.solicitudForm.controls["placaPaisMatricula"].value;
        this.import.make = this.solicitudForm.controls["marcaId"].value;
        this.import.model = this.solicitudForm.controls["anoModeloId"].value;
        this.import.engineNumber = this.solicitudForm.controls["numeroMotorId"].value;
        this.import.countryOfRegistration = this.solicitudForm.controls["paisMatriculaId"].value;
        this.import.color = this.solicitudForm.controls["colorId"].value;
        this.import.transportationName = this.solicitudForm.controls["nombreBuqueId"].value;
        this.import.nameFlag = this.solicitudForm.controls["nombreBanderaId"].value;
        this.import.entryPlace = this.solicitudForm.controls["lugarIngresoId"].value;
        this.import.registrationNumber = this.solicitudForm.controls["numeroMatriculaId"].value;
        this.import.transportationChars = this.solicitudForm.controls["carMedioTransporte"].value;
        this.import.othersChars = this.solicitudForm.controls["anotherChars"].value;
        this.import.importDate = this.fecharegistro;
        this.import.nombreContenedor = this.codigo;
        this.import.typeVehicle = this.solicitudForm.controls["tipoId"].value;          

          const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };

          this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=1,2,3,4,5,6&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
            .subscribe({
              next: data => {
                var importsold = data as Import[];
                var importold = importsold[0];
                if (importold == null) {
                  this.http.post<string>(`${environment.baseUrl}v1/import`, this.import, { headers })
                    .subscribe({
                      next: data => {
                        this.postId = data;

                        this.solicitudForm.controls["aduanaIngreso"].disable();
                        this.solicitudForm.controls["aduanaSalida"].disable();
                        this.solicitudForm.controls["nombreTuristaId"].disable();
                        this.solicitudForm.controls["paisResidenciaTurista"].disable();
                        this.solicitudForm.controls["numeroPasaporteId"].disable();
                        this.solicitudForm.controls["nacionalidadId"].disable();
                        this.solicitudForm.controls["fechaLlegadaId"].disable();
                        this.solicitudForm.controls["ciudadHospedajeId"].disable();
                        this.solicitudForm.controls["direccionHospedajeId"].disable();
                        this.solicitudForm.controls["diasAutorizadosId"].disable();
                        this.solicitudForm.controls["correoElectronicoId"].disable();
                        this.solicitudForm.controls["fechaIngresoId"].disable();
                        this.solicitudForm.controls["fechaSalidaId"].disable();
                        this.solicitudForm.controls["formaIngresoVehiculoId"].disable();
                        this.solicitudForm.controls["numeroDocTransporteId"].disable();
                        this.solicitudForm.controls["numeroDocumento1166Id"].disable();
                        this.solicitudForm.controls["numerodocpropiedad"].disable();
                        this.solicitudForm.controls["fechaMatricula"].disable();
                        this.solicitudForm.controls["claseId"].disable();
                        this.solicitudForm.controls["idMedioTransporteVIN"].disable();
                        this.solicitudForm.controls["placaPaisMatricula"].disable();
                        this.solicitudForm.controls["marcaId"].disable();
                        this.solicitudForm.controls["anoModeloId"].disable();
                        this.solicitudForm.controls["numeroMotorId"].disable();
                        this.solicitudForm.controls["paisMatriculaId"].disable();
                        this.solicitudForm.controls["colorId"].disable();
                        this.solicitudForm.controls["nombreBuqueId"].disable();
                        this.solicitudForm.controls["nombreBanderaId"].disable();
                        this.solicitudForm.controls["lugarIngresoId"].disable();
                        this.solicitudForm.controls["numeroMatriculaId"].disable();
                        this.solicitudForm.controls["carMedioTransporte"].disable();
                        this.solicitudForm.controls["anotherChars"].disable();
                        this.solicitudForm.controls["tipoId"].disable();

                        this.estado = "EN REVISIÓN";
                        this.wait = true;
                        this.cancel = false;
                        this.ok = false;
                        this.ext = false;
                        this.ven = false;
                        this.fin = false;

                        this.SolicitudShow = false;
                        this.ConsultarShow = true;
                        this.accion = "consulta";

                        let element6: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                        element6.click();

                        let element: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
                        element.click();

                        this.http.get<any>(`${environment.baseUrl}v1/parametros/8?codigo=` + this.import.sectionalAddressIn)
                          .subscribe({
                            next: data => {
                              this.seccional = data as SeccionalAduanera;
                              this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                                .subscribe({
                                  next: data => {
                                    this.sendmail = data as SendMail;
                                    this.sendmail.asunto = "Acuse recibo solicitud de importación temporal de turismo";
                                    this.sendmail.email = this.import.email;
                                    this.sendmail.emailCopy = "null";
                                    this.sendmail.mensaje = "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td><table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td style='font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #262944; padding-top: 30px;' class='padding-copy'><b>Notificación de servicio</b><br/><span style='font-size: 20px;'>Importación temporal de turismo</span> </td></tr><tr><td style='padding: 30px 0 0 0; font-size: 16px; line-height: 22px; font-family: Helvetica, Arial, sans-serif; color: #2B323D;' class='padding-copy'><p>Buen día,</p><p><span style='font-weight: bold;'>" + this.import.touristName + "</span></p><p style='padding: 30px 0 0 0;'>Tu solicitud de <span style='font-weight: bold;'>importación temporal de turismo</span> del medio de transporte con número de identificación (VIN o Serial) <span style='font-weight: bold;'>" + this.import.chassisNumber + "</span> ha sido registrada y recibida por el área de operación aduanera de la DIAN - <span style='font-weight: bold;'>" + this.seccional.nombre + "</span></p><p style='padding:20px 20px 20px 20px;background-color: #ccf0f8;'>Este registro no te autoriza para circular por el territorio aduanero nacional. Una vez llegues al país, debes acercarte a la aduana de ingreso para finalizar el proceso de importación temporal de turismo del medio de transporte.</p><p style='padding: 40px 0 0 0;'>Cordialmente,</p><p><span style='font-weight: bold;'>Dirección de Impuestos y Aduanas Nacionales - DIAN</span></p><p style='padding: 0 0 0 0;'>Gestión de Operación Aduanera</p></td></tr></table></td></tr></table>";

                                    this.http.post<string>(`${environment.baseUrl}v1/sendmail`, this.sendmail, { headers })
                                      .subscribe({
                                        next: data => {

                                        },
                                        error: error => {
                                          this.errorMessage = error.message;
                                        }
                                      })
                                  },
                                  error: error => {
                                    this.errorMessage = error.message;
                                  }
                                })
                            },
                            error: error => {
                              this.errorMessage = error.message;
                              //console.error('There was an error!', error);
                            }
                          })

                        this.tooladuanaIngreso = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressIn)[0].nombre;
                        this.tooladuanaSalida = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressOut)[0].nombre;
                        this.toolpaisResidenciaTurista = this.Paises.filter(se => se.codigo == this.import.touristCountry)[0].nombre;
                        this.toolpaisMatriculaId = this.Paises.filter(se => se.codigo == this.import.countryOfRegistration)[0].nombre;
                        if (this.import.typeClass == "2") {
                          this.toolnombreBanderaId = this.Paises.filter(se => se.codigo == this.import.nameFlag)[0].nombre;
                        } 
                        this.toolciudadHospedajeId = this.Ciudades.filter(se => se.codigo == this.import.touristCity)[0].nombre;
                        this.toolformaIngreso = (this.import.vehicleEntryForm == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por Carga" : "Per charge") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por sus propios medios" : "On their own"))
                        this.toolclase = (this.import.typeClass == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Automóviles y demás vehículos terrestres" : "Cars and other land vehicles") : (this.import.typeClass == "2" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Barcos y demás artefactos flotantes" : "Boats and floating structures") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Aeronaves" : "Aircraft")))
                        this.toollugarIngreso = this.LugaresIngreso.filter(se => se.codigo == this.import.entryPlace)[0].nombre;
                      },
                      error: error => {
                        let element7: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                        element7.click();
                        let element: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
                        element.click();
                        this.solicitudForm.controls["customTarget"].setValue("errorModal");

                        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                          this.errorMessage = "Algo salió mal, por favor";
                        } else {
                          this.errorMessage = "Something went wrong, please";
                        }
                      }
                    })
                }
                else {
                  this.solicitudForm.controls["aduanaIngreso"].disable();
                  this.solicitudForm.controls["aduanaSalida"].disable();
                  this.solicitudForm.controls["nombreTuristaId"].disable();
                  this.solicitudForm.controls["paisResidenciaTurista"].disable();
                  this.solicitudForm.controls["numeroPasaporteId"].disable();
                  this.solicitudForm.controls["nacionalidadId"].disable();
                  this.solicitudForm.controls["fechaLlegadaId"].disable();
                  this.solicitudForm.controls["ciudadHospedajeId"].disable();
                  this.solicitudForm.controls["direccionHospedajeId"].disable();
                  this.solicitudForm.controls["diasAutorizadosId"].disable();
                  this.solicitudForm.controls["correoElectronicoId"].disable();
                  this.solicitudForm.controls["fechaIngresoId"].disable();
                  this.solicitudForm.controls["fechaSalidaId"].disable();
                  this.solicitudForm.controls["formaIngresoVehiculoId"].disable();
                  this.solicitudForm.controls["numeroDocTransporteId"].disable();
                  this.solicitudForm.controls["numeroDocumento1166Id"].disable();
                  this.solicitudForm.controls["numerodocpropiedad"].disable();
                  this.solicitudForm.controls["fechaMatricula"].disable();
                  this.solicitudForm.controls["claseId"].disable();
                  this.solicitudForm.controls["idMedioTransporteVIN"].disable();
                  this.solicitudForm.controls["placaPaisMatricula"].disable();
                  this.solicitudForm.controls["marcaId"].disable();
                  this.solicitudForm.controls["anoModeloId"].disable();
                  this.solicitudForm.controls["numeroMotorId"].disable();
                  this.solicitudForm.controls["paisMatriculaId"].disable();
                  this.solicitudForm.controls["colorId"].disable();
                  this.solicitudForm.controls["nombreBuqueId"].disable();
                  this.solicitudForm.controls["nombreBanderaId"].disable();
                  this.solicitudForm.controls["lugarIngresoId"].disable();
                  this.solicitudForm.controls["numeroMatriculaId"].disable();
                  this.solicitudForm.controls["carMedioTransporte"].disable();
                  this.solicitudForm.controls["anotherChars"].disable();
                  this.solicitudForm.controls["tipoId"].disable();

                  this.estado = "EN REVISIÓN";
                  this.wait = true;
                  this.cancel = false;
                  this.ok = false;
                  this.ext = false;
                  this.ven = false;
                  this.fin = false;

                  this.SolicitudShow = false;
                  this.ConsultarShow = true;
                  this.accion = "consulta";

                  let element6: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                  element6.click();

                  let element: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
                  element.click();

                  this.http.get<any>(`${environment.baseUrl}v1/parametros/8?codigo=` + this.import.sectionalAddressIn)
                    .subscribe({
                      next: data => {
                        this.seccional = data as SeccionalAduanera;
                        this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                          .subscribe({
                            next: data => {
                              this.sendmail = data as SendMail;
                              this.sendmail.asunto = "Acuse recibo solicitud de importación temporal de turismo";
                              this.sendmail.email = this.import.email;
                              this.sendmail.emailCopy = "null";
                              this.sendmail.mensaje = "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td><table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td style='font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #262944; padding-top: 30px;' class='padding-copy'><b>Notificación de servicio</b><br/><span style='font-size: 20px;'>Importación temporal de turismo</span> </td></tr><tr><td style='padding: 30px 0 0 0; font-size: 16px; line-height: 22px; font-family: Helvetica, Arial, sans-serif; color: #2B323D;' class='padding-copy'><p>Buen día,</p><p><span style='font-weight: bold;'>" + this.import.touristName + "</span></p><p style='padding: 30px 0 0 0;'>Tu solicitud de <span style='font-weight: bold;'>importación temporal de turismo</span> del medio de transporte con número de identificación (VIN o Serial) <span style='font-weight: bold;'>" + this.import.chassisNumber + "</span> ha sido registrada y recibida por el área de operación aduanera de la DIAN - <span style='font-weight: bold;'>" + this.seccional.nombre + "</span></p><p style='padding:20px 20px 20px 20px;background-color: #ccf0f8;'>Este registro no te autoriza para circular por el territorio aduanero nacional. Una vez llegues al país, debes acercarte a la aduana de ingreso para finalizar el proceso de importación temporal de turismo del medio de transporte.</p><p style='padding: 40px 0 0 0;'>Cordialmente,</p><p><span style='font-weight: bold;'>Dirección de Impuestos y Aduanas Nacionales - DIAN</span></p><p style='padding: 0 0 0 0;'>Gestión de Operación Aduanera</p></td></tr></table></td></tr></table>";

                              this.http.post<string>(`${environment.baseUrl}v1/sendmail`, this.sendmail, { headers })
                                .subscribe({
                                  next: data => {

                                  },
                                  error: error => {
                                    this.errorMessage = error.message;
                                  }
                                })
                            },
                            error: error => {
                              this.errorMessage = error.message;
                            }
                          })
                      },
                      error: error => {
                        this.errorMessage = error.message;
                        //console.error('There was an error!', error);
                      }
                    })

                  this.tooladuanaIngreso = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressIn)[0].nombre;
                  this.tooladuanaSalida = this.Seccionales.filter(se => se.codigo == this.import.sectionalAddressOut)[0].nombre;
                  this.toolpaisResidenciaTurista = this.Paises.filter(se => se.codigo == this.import.touristCountry)[0].nombre;
                  this.toolpaisMatriculaId = this.Paises.filter(se => se.codigo == this.import.countryOfRegistration)[0].nombre;
                  if (this.import.typeClass == "2") {
                    this.toolnombreBanderaId = this.Paises.filter(se => se.codigo == this.import.nameFlag)[0].nombre;
                  } 
                  this.toolciudadHospedajeId = this.Ciudades.filter(se => se.codigo == this.import.touristCity)[0].nombre;
                  this.toolformaIngreso = (this.import.vehicleEntryForm == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por Carga" : "Per charge") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Por sus propios medios" : "On their own"))
                  this.toolclase = (this.import.typeClass == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Automóviles y demás vehículos terrestres" : "Cars and other land vehicles") : (this.import.typeClass == "2" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Barcos y demás artefactos flotantes" : "Boats and floating structures") : (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Aeronaves" : "Aircraft")))
                  this.toollugarIngreso = this.LugaresIngreso.filter(se => se.codigo == this.import.entryPlace)[0].nombre;
                }
              }
            })        
      }
    } else {
      this.validarcampos();
      var formaingreso = this.solicitudForm.controls["formaIngresoVehiculoId"].value;
      var clase = this.solicitudForm.controls["claseId"].value;
      if (formaingreso == "1") {
        this.cambionumeroDocTransporteId();
        this.cambionumeroDocumento1166Id();
      }
      if (clase == "2") {
        this.cambionombreBuqueId();
        this.cambionombreBanderaId();
      }
      let element4: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
      element4.click();
      let element5: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
      element5.click();
      this.solicitudForm.controls["customTarget"].setValue("errorModal");
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
      } else {
        this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
      }
    }
  }

  habNoTrans() {
    this.cambioformaIngresoVehiculoId();
    var formaingreso = this.solicitudForm.controls["formaIngresoVehiculoId"].value;
    if (formaingreso == "1") {
      this.solicitudForm.controls["numeroDocTransporteId"].enable();
      this.solicitudForm.controls["numeroDocumento1166Id"].enable();
    }
    else {
      this.solicitudForm.controls["numeroDocTransporteId"].disable();
      this.solicitudForm.controls["numeroDocumento1166Id"].disable();

      this.solicitudForm.patchValue({
        numeroDocTransporteId: "",
        numeroDocumento1166Id: ""
      });

      this.errornumeroDocTransporteId = false;
      this.errornumeroDocumento1166IdRequerido = false;
    }    
  }

  habNomBuque() {
    this.cambioclaseId();
    var clase = this.solicitudForm.controls["claseId"].value;
    if (clase == "2") {
      this.solicitudForm.controls["nombreBuqueId"].enable();
      this.solicitudForm.controls["nombreBanderaId"].enable();
    }
    else {
      this.solicitudForm.controls["nombreBuqueId"].disable();
      this.solicitudForm.controls["nombreBanderaId"].disable();

      this.solicitudForm.patchValue({
        nombreBuqueId: "",
        nombreBanderaId: ""
      });

      this.errornombreBuqueId = false;
      this.errornombreBanderaId = false;
    }
  }  

  cambioseccional() {
    this.cambioaduanaIngreso();
    var codigo = this.solicitudForm.controls["aduanaIngreso"].value;
    if (codigo != "") {
      this.http.get<any>(`${environment.baseUrl}v1/parametros/5?codigo=` + codigo)
        .subscribe({
          next: data => {
            this.LugaresIngreso = data as LugarIngreso[];
            //this.router.navigate(["/import-request/solicitud"]);
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
          }
        })
    }
    else {
      this.LugaresIngreso = [];
    }
  }

  //cambiolugar() {
  //  var codigo = this.solicitudForm.controls["lugarIngresoId"].value;
  //  if (codigo == "1") {
  //    this.ShowOther = true;
  //  }
  //  else {
  //    this.ShowOther = false;
  //    this.solicitudForm.patchValue({
  //      otroId: ""
  //    });
  //  }
  //}

  cambiofechainicio() {
    this.cambiofechaIngresoId();
    var fecha = this.solicitudForm.controls["fechaIngresoId"].value;
    if (fecha == "") {
      this.solicitudForm.patchValue({
        fechaSalidaId: ""
      });
      this.dateend = new Date().toJSON().split('T')[0];
    } else {
      var dateselect = new Date(fecha).toJSON().split('T')[0];
      var today = new Date().toJSON().split('T')[0];
      if (dateselect < today) {
        this.solicitudForm.patchValue({
          fechaIngresoId: "",
          fechaSalidaId: ""
        });
        this.dateend = new Date().toJSON().split('T')[0];
      } else {
        this.dateend = new Date(fecha).toJSON().split('T')[0];
      }       
    }
  }

  cambiofechallegada() {
    this.cambiofechaLlegadaId();
    var fecha = this.solicitudForm.controls["fechaLlegadaId"].value;
    if (fecha != "") {
      var dateselect = new Date(fecha).toJSON().split('T')[0];
      var today = new Date().toJSON().split('T')[0];
      if (dateselect < today) {
        this.solicitudForm.patchValue({
          fechaLlegadaId: ""
        });
      } else {

      }  
    }
      
  }

  cambiofechafin() {
    this.cambiofechaSalidaId();
    var fechai = this.solicitudForm.controls["fechaIngresoId"].value;
    var fechaf = this.solicitudForm.controls["fechaSalidaId"].value;
    if (fechaf != "") {
      if (fechai != "") {
        var datei = new Date(fechai).toJSON().split('T')[0];
        var datef = new Date(fechaf).toJSON().split('T')[0];
        if (datei > datef) {
          this.solicitudForm.patchValue({
            fechaSalidaId: ""
          });
        } else {

        }
      }
      else {
        var datei = new Date().toJSON().split('T')[0];
        var datef = new Date(fechaf).toJSON().split('T')[0];
        if (datei > datef) {
          this.solicitudForm.patchValue({
            fechaSalidaId: ""
          });
        } else {

        }
      }
    }
    
  }

  validarcampos() {
    this.cambioaduanaIngreso();
    this.cambioaduanaSalida();
    this.cambionombreTuristaId();
    this.cambiopaisResidenciaTurista();
    this.cambionumeroPasaporteId();
    this.cambionacionalidadId();
    this.cambiofechaLlegadaId();
    this.cambiociudadHospedajeId();
    this.cambiodireccionHospedajeId();
    this.cambiodiasAutorizadosId();
    this.cambiofechaIngresoId();
    this.cambiofechaSalidaId();
    this.cambioformaIngresoVehiculoId();    
    this.cambionumerodocpropiedad();
    this.cambiofechaMatricula();
    this.cambioclaseId();
    this.cambioplacaPaisMatricula();
    this.cambiomarcaId();
    this.cambioanoModeloId();
    this.cambionumeroMotorId();
    this.cambiopaisMatriculaId();
    this.cambiocolorId();    
    this.cambiolugarIngresoId();
    this.cambionumeroMatriculaId();
    this.cambiocarMedioTransporte();
    this.cambioanotherChars();
    this.cambiotipoId();
  }

  cambioaduanaIngreso() {
    var valor = this.solicitudForm.controls["aduanaIngreso"].value;
    if (valor == "") {
      this.erroraduanaIngreso = true;
    }
    else {
      this.erroraduanaIngreso = false;
    }
  }
  cambioaduanaSalida() {
    var valor = this.solicitudForm.controls["aduanaSalida"].value;
    if (valor == "") {
      this.erroraduanaSalida = true;
    }
    else {
      this.erroraduanaSalida = false;
    }
  }
  cambionombreTuristaId() {
    var valor = this.solicitudForm.controls["nombreTuristaId"].value;
    if (valor == "") {
      this.errornombreTuristaId = true;
    }
    else {
      this.errornombreTuristaId = false;
    }
  }
  cambiopaisResidenciaTurista() {
    var valor = this.solicitudForm.controls["paisResidenciaTurista"].value;
    if (valor == "") {
      this.errorpaisResidenciaTurista = true;
    }
    else {
      this.errorpaisResidenciaTurista = false;
    }
  }
  cambionumeroPasaporteId() {
    var valor = this.solicitudForm.controls["numeroPasaporteId"].value;
    if (valor == "") {
      this.errornumeroPasaporteId = true;
    }
    else {
      this.errornumeroPasaporteId = false;
    }
  }
  cambionacionalidadId() {
    var valor = this.solicitudForm.controls["nacionalidadId"].value;
    if (valor == "") {
      this.errornacionalidadIdRequerido = true;
    }
    else {
      this.errornacionalidadIdRequerido = false;
    }
  }
  cambiofechaLlegadaId() {
    var valor = this.solicitudForm.controls["fechaLlegadaId"].value;
    if (valor == "") {
      this.errorfechaLlegadaId = true;
    }
    else {
      this.errorfechaLlegadaId = false;
    }
  }
  cambiociudadHospedajeId() {
    var valor = this.solicitudForm.controls["ciudadHospedajeId"].value;
    if (valor == "") {
      this.errorciudadHospedajeId = true;
    }
    else {
      this.errorciudadHospedajeId = false;
    }
  }
  cambiodireccionHospedajeId() {
    var valor = this.solicitudForm.controls["direccionHospedajeId"].value;
    if (valor == "") {
      this.errordireccionHospedajeId = true;
    }
    else {
      this.errordireccionHospedajeId = false;
    }
  }
  cambiodiasAutorizadosId() {
    var valor = this.solicitudForm.controls["diasAutorizadosId"].value;
    if (valor == "") {
      this.errordiasAutorizadosIdRequerido = true;
    }
    else {
      this.errordiasAutorizadosIdRequerido = false;
    }
  }  
  cambiofechaIngresoId() {
    var valor = this.solicitudForm.controls["fechaIngresoId"].value;
    if (valor == "") {
      this.errorfechaIngresoId = true;
    }
    else {
      this.errorfechaIngresoId = false;
    }
  }
  cambiofechaSalidaId() {
    var valor = this.solicitudForm.controls["fechaSalidaId"].value;
    if (valor == "") {
      this.errorfechaSalidaId = true;
    }
    else {
      this.errorfechaSalidaId = false;
    }
  }
  cambioformaIngresoVehiculoId() {
    var valor = this.solicitudForm.controls["formaIngresoVehiculoId"].value;
    if (valor == "") {
      this.errorformaIngresoVehiculoId = true;
    }
    else {
      this.errorformaIngresoVehiculoId = false;
    }
  }
  cambionumeroDocTransporteId() {
    var valor = this.solicitudForm.controls["numeroDocTransporteId"].value;
    if (valor == "") {
      this.errornumeroDocTransporteId = true;
    }
    else {
      this.errornumeroDocTransporteId = false;
    }
  }
  cambionumeroDocumento1166Id() {
    var valor = this.solicitudForm.controls["numeroDocumento1166Id"].value;
    if (valor == "") {
      this.errornumeroDocumento1166IdRequerido = true;
    }
    else {
      this.errornumeroDocumento1166IdRequerido = false;
    }
  }
  cambionumerodocpropiedad() {
    var valor = this.solicitudForm.controls["numerodocpropiedad"].value;
    if (valor == "") {
      this.errornumerodocpropiedad = true;
    }
    else {
      this.errornumerodocpropiedad = false;
    }
  }
  cambiofechaMatricula() {
    var valor = this.solicitudForm.controls["fechaMatricula"].value;
    if (valor == "") {
      this.errorfechaMatricula = true;
    }
    else {
      this.errorfechaMatricula = false;
    }
  }
  cambioclaseId() {
    var valor = this.solicitudForm.controls["claseId"].value;
    if (valor == "") {
      this.errorclaseId = true;
    }
    else {
      this.errorclaseId = false;
    }
  }
  cambioplacaPaisMatricula() {
    var valor = this.solicitudForm.controls["placaPaisMatricula"].value;
    if (valor == "") {
      this.errorplacaPaisMatricula = true;
    }
    else {
      this.errorplacaPaisMatricula = false;
    }
  }
  cambiomarcaId() {
    var valor = this.solicitudForm.controls["marcaId"].value;
    if (valor == "") {
      this.errormarcaId = true;
    }
    else {
      this.errormarcaId = false;
    }
  }
  cambioanoModeloId() {
    var valor = this.solicitudForm.controls["anoModeloId"].value;
    if (valor == "") {
      this.erroranoModeloIdRequerido = true;
    }
    else {
      this.erroranoModeloIdRequerido = false;
    }
  }
  cambionumeroMotorId() {
    var valor = this.solicitudForm.controls["numeroMotorId"].value;
    if (valor == "") {
      this.errornumeroMotorId = true;
    }
    else {
      this.errornumeroMotorId = false;
    }
  }
  cambiopaisMatriculaId() {
    var valor = this.solicitudForm.controls["paisMatriculaId"].value;
    if (valor == "") {
      this.errorpaisMatriculaId = true;
    }
    else {
      this.errorpaisMatriculaId = false;
    }
  }
  cambiocolorId() {
    var valor = this.solicitudForm.controls["colorId"].value;
    if (valor == "") {
      this.errorcolorId = true;
    }
    else {
      this.errorcolorId = false;
    }
  }
  cambionombreBuqueId() {
    var valor = this.solicitudForm.controls["nombreBuqueId"].value;
    if (valor == "") {
      this.errornombreBuqueId = true;
    }
    else {
      this.errornombreBuqueId = false;
    }
  }
  cambionombreBanderaId() {
    var valor = this.solicitudForm.controls["nombreBanderaId"].value;
    if (valor == "") {
      this.errornombreBanderaId = true;
    }
    else {
      this.errornombreBanderaId = false;
    }
  }
  cambiolugarIngresoId() {
    var valor = this.solicitudForm.controls["lugarIngresoId"].value;
    if (valor == "") {
      this.errorlugarIngresoId = true;
    }
    else {
      this.errorlugarIngresoId = false;
    }
  }
  cambionumeroMatriculaId() {
    var valor = this.solicitudForm.controls["numeroMatriculaId"].value;
    if (valor == "") {
      this.errornumeroMatriculaId = true;
    }
    else {
      this.errornumeroMatriculaId = false;
    }
  }
  cambiocarMedioTransporte() {
    var valor = this.solicitudForm.controls["carMedioTransporte"].value;
    if (valor == "") {
      this.errorcarMedioTransporte = true;
    }
    else {
      this.errorcarMedioTransporte = false;
    }
  }
  cambioanotherChars() {
    var valor = this.solicitudForm.controls["anotherChars"].value;
    if (valor == "") {
      this.erroranotherChars = true;
    }
    else {
      this.erroranotherChars = false;
    }
  }
  cambiotipoId() {
    var valor = this.solicitudForm.controls["tipoId"].value;
    if (valor == "") {
      this.errortipoId = true;
    }
    else {
      this.errortipoId = false;
    }
  }

  cancelar() {
    this.showModalBoxCancelar = true;
  }

  sicancelar() {
    if (this.volver == "validate-email") {
      //this.cookies.deleteAll(environment.raiz, environment.dominio)
      this.cookies.delete("tokensessionTurista", environment.raiz, environment.dominio)
      this.router.navigate(["/" + this.volver]);
    }
    else {
      this.router.navigate(["/" + this.volver + "/" + this.email + "/" + this.numeroserial]);
    } 
  }

  verprorroga(idImport,id) {
    this.router.navigate(["/extension/" + "consulta" + "/" + idImport + "/" + id]);
  }

  validatenacionalidadId() {
    this.cambionacionalidadId();
    var regexp = new RegExp(/^[A-Za-z\s]*$/);
    var valor = this.solicitudForm.controls["nacionalidadId"].value;
    
    if (!regexp.test(valor)) {
      this.errornacionalidadId = true;
    }
    else {
      this.errornacionalidadId = false;
    }
  }

  validatediasAutorizadosId() {
    this.cambiodiasAutorizadosId();
    var regexp = new RegExp(/^[0-9]*$/);
    var valor = this.solicitudForm.controls["diasAutorizadosId"].value;

    if (!regexp.test(valor)) {
      this.errordiasAutorizadosId = true;
    }
    else {
      this.errordiasAutorizadosId = false;
    }
  }

  validatenumeroDocumento1166Id() {
    this.cambionumeroDocumento1166Id();
    var regexp = new RegExp(/^[0-9]*$/);
    var valor = this.solicitudForm.controls["numeroDocumento1166Id"].value;

    if (!regexp.test(valor)) {
      this.errornumeroDocumento1166Id = true;
    }
    else {
      this.errornumeroDocumento1166Id = false;
    }
  }

  validateanoModeloId() {
    this.cambioanoModeloId();
    var regexp = new RegExp(/^[0-9]*$/);
    var valor = this.solicitudForm.controls["anoModeloId"].value;

    if (!regexp.test(valor)) {
      this.erroranoModeloId = true;
    }
    else {
      this.erroranoModeloId = false;
    }
  }
}

interface SeccionalAduanera {
  codigo: string;
  nombre: string;
}

interface Pais {
  codigo: string;
  nombre: string;
}

interface Ciudad {
  codigo: string;
  nombre: string;
}

interface FormaIngreso {
  codigoTipoDep: string;
  tipoDeposito: string;
}

interface LugarIngreso {
  codigo: string;
  nombre: string;
}

class Import {
  id: string;
  sectionalAddressIn: string;
	sectionalAddressOut: string;
	touristName: string;
	touristCountry: string;
	passportNumber: string;
	nationality: string;
	dateOfArrival: string;
	touristCity: string;
	touristAddress: string;
	authorizedDuration: string;
	email: string;
	dateIn: string;
	dateOut: string;
	vehicleEntryForm: string;
	transportDocumentNumber: string;
	n1166DocumentNumber: string;
	ownershipDocumentNumber: string;
	registrationDate: string;
	typeClass: string;
	chassisNumber: string;
	licensePlate: string;
	make: string;
  model: string;
	engineNumber: string;
	countryOfRegistration: string;
	color: string;
	transportationName: string;
	nameFlag: string;
	entryPlace: string;
	registrationNumber: string;
	transportationChars: string;
  othersChars: string;
  idStatus: string;
  importDate: string;
  nombreContenedor: string;
  typeVehicle: string;
  otherPlace: string;
  justification: string;
}

class Extend {
  id: string;
  sectionalAddress: string;
  sectionalName: string
  authorizedDuration: string;
  initialDate: string;
  endDate: string;
  touristCity: string;
  touristAddress: string;
  justification: string;
  authorization: string;
  tidAssignee: string;
  idAssignee: string;
  nameAssignee: string;
  emailAssignee: string;
  registrationDate: string;
  idImport: string;
  idStatus: string;
  estado: string;
  justificationRejection: string;
}

class SendMail {
  asunto: string;
  email: string;
  mensaje: string;
  emailCopy: string;
  token: string;
}
